/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SavingAccountOutputDto { 
    id?: number;
    savingProductId?: number;
    accountId?: number;
    savingProductName?: string | null;
    accountCode?: string | null;
    accountNumber?: string | null;
    balance?: number;
    blockedAmount?: number | null;
    openingDate?: string | null;
    maturityDate?: string | null;
    interestRate?: number | null;
    minimumTransactionAmount?: number | null;
    maximumTransactionAmount?: number | null;
    minimumBalance?: number;
    allowedAsGuarantor?: boolean;
    allowedAsCollateral?: boolean;
    savingProductType?: string | null;
    openingBalance?: number | null;
    productSettingId?: number | null;
    accountStatus?: string | null;
    memberName?: string | null;
    memberType?: string | null;
    userId?: number;
    memberId?: string | null;
    accountName?: string | null;
    allowOverdraft?: boolean;
    overdraftAccountLimit?: number | null;
    allowWithdrawal?: boolean;
    twoFactorAuthentication?: boolean;
}

